import React, { useState, useEffect } from 'react';

import Query from '@queries/quiz/StepThree';
import { saveUser } from '@redux/user/actions';
import { quizFormNextStep, quizFormPrevStep, quizFormSetRedirect, quizFormSetCalendly } from '@redux/quiz/actions';
import { useDispatch, useSelector } from 'react-redux';
import { states } from '@helpers/states';
import { getSalesCalendlyLink } from '@helpers/sales';

import { useForm } from 'react-hook-form';
import Form from 'react-bootstrap/Form';

import Heading from '@common/Heading';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const StepThree = ({ nextStep, previousStep }) => {
  const data = Query();
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const {
    centerName,
    titleRedirect,
    enrollmentRangeLabel,
    enrollmentRangeList,
    centerEnrolmentLabel,
    centerEnrolmentList
  } = data.contentfulFormFields;
  const [showCenterEnrolmentField, setShowCenterEnrolmentField] = useState(false);
  const { register, formState: { errors }, handleSubmit } = useForm({
    defaultValues: {
      centerName: user.centerName,
      enrollmentRange: user.enrollmentRange,
      centerEnrolment: user.centerEnrolment,
      stateProvince: user.stateProvince,
      currentSolution: user.currentSolution
    }
  });
  const onSubmit = ( data ) => {
    dispatch(saveUser(data));
    const redirect = titleRedirect.find(x => x.title === user.title);
    if (redirect) {
      dispatch(quizFormSetRedirect(redirect.link));
    }
    const calendly = getSalesCalendlyLink(data, user.title);
    if (calendly) {
      dispatch(quizFormSetCalendly(calendly.link));
      dispatch(quizFormNextStep());
      nextStep();
    }
  };
  const handlePrevStep = () => {
    dispatch(quizFormPrevStep());
    previousStep();
  }
  useEffect(() => {
    const isHomeDaycare = user.title === 'Home Daycare Provider';
    setShowCenterEnrolmentField(isHomeDaycare);
  }, [user]);
  return (
    <Form noValidate onSubmit={handleSubmit(onSubmit)} className='demo-quiz-form'>
      <Heading type='h2' className='fs-32 mb-3'>{'Let\'s learn more about your center!'}</Heading>
      <div className='col-lg-7'>
        <Form.Group controlId='centerName' className='mb-3 required'>
          <Form.Label>{centerName}</Form.Label>
          <Form.Control
            name='centerName'
            type='text'
            placeholder={centerName}            
            required
            isInvalid={!!errors.centerName}
            {...register('centerName', { required: 'Please type in your center name.' })}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.centerName?.message}
          </Form.Control.Feedback>
        </Form.Group>
        {!showCenterEnrolmentField &&
          <Form.Group controlId='enrollmentRange' className='mb-3 required'>
            <Form.Label>{enrollmentRangeLabel}</Form.Label>
            <Form.Select
              name='enrollmentRange'
              required
              defaultValue={user.enrollmentRange}
              isInvalid={!!errors.enrollmentRange}
              {...register('enrollmentRange', { required: true })}
            >
              <option value=''>{enrollmentRangeLabel}</option>
              {enrollmentRangeList.map((size, index) => (
                <option key={index} value={size}>{size}</option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type='invalid'>
              {errors.enrollmentRange?.message}
            </Form.Control.Feedback>
          </Form.Group>
        }
        {showCenterEnrolmentField &&
          <Form.Group controlId='centerEnrolment' className='mb-3 required'>
            <Form.Label>{centerEnrolmentLabel}</Form.Label>
            <Form.Select
              name='centerEnrolment'
              required
              isInvalid={!!errors.centerEnrolment}
              {...register('centerEnrolment', { required: true })}
            >
              <option value=''>{centerEnrolmentLabel}</option>
              {centerEnrolmentList.map((size, index) => (
                <option key={index} value={size}>{size}</option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type='invalid'>
              {errors.centerEnrolment?.message}
            </Form.Control.Feedback>
          </Form.Group>
        }
        <Form.Group controlId='stateProvince' className='mb-3 required'>
          <Form.Label>{'State/Province'}</Form.Label>
          <Form.Select
            name='stateProvince'
            required
            isInvalid={!!errors.stateProvince}
            {...register('stateProvince', { required: 'State/Province is required.' })}
          >
            <option value=''>{'State/Province'}</option>
            {states.map((state, index) => (
              <option key={index} value={state.value}>{state.key}</option>
            ))}
          </Form.Select>
          <Form.Control.Feedback type='invalid'>
            {errors.stateProvince?.message}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group controlId='currentSolution' className='mb-3 required'>
          <Form.Label>{'Do you currently use a digital childcare management platform?'}</Form.Label>
          <Form.Select
            name='currentSolution'
            required
            defaultValue={user.currentSolution}
            {...register('currentSolution', { required: 'Please select an option', validate: { doesNotEqualBlank: (value) => {
              return value !== '';
            }} })}
          >
            <option value=''>{'Yes/No'}</option>
            <option value={true}>{'Yes'}</option>
            <option value={false}>{'No'}</option>
          </Form.Select>
          <Form.Control.Feedback type='invalid'>
            {errors.currentSolution?.message}
          </Form.Control.Feedback>
        </Form.Group>
      </div>
      <div className='d-flex justify-content-between'>
        <button type='button' onClick={handlePrevStep} className='btn shadow-none'>
          <FontAwesomeIcon icon={faArrowLeft} size='lg'/>
          <span className='sr-only sr-only-focusable'>Previous Step</span>
        </button>
        <button type='submit' className='btn btn-primary btn-lg btn-pink-bright'>{'Next'}</button>
      </div>
    </Form>
  )
}

export default StepThree
